import { Injectable } from '@angular/core';
import { Headers, Response, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { DomainAddresses } from '../constants';
import { Area } from '../models';

declare const jQuery

@Injectable()
export class AreaService {

    constructor(
        private _http: Http
    ) { }

    private readonly _requestOptionsArgs = {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    }

    getAreas(): Observable<Area[]> {
        return this._http.get(`${DomainAddresses.MAPS_API_DOMAIN}/areas`, this._requestOptionsArgs)
            .map(response => {
                const areas = response.json()

                return areas.map(a => ({ ...a, geometry: JSON.parse(a.geometry) }))
            })
            .catch(error => {
                return Observable.throw(error.json().errors)
            })
    }
}



// WEBPACK FOOTER //
// /app/src/shared/services/area.service.ts